<template>
    <div class="Summary">
        <div class="row">
            <div class="col col-md-4">
                <h4>Child Info</h4>
                <p><span class="bold">Name: </span><span>{{ ChildRecordData.Client.Person.FirstName }}</span> <span v-if="ChildRecordData.Client.Person.AKA">"{{ ChildRecordData.Client.Person.AKA }}"</span> <span>{{ ChildRecordData.Client.Person.LastName }}</span></p>
                <p><span class="bold">DOB: </span><span>{{ formatDate(ChildRecordData.Client.Person.DOB, 'MM/DD/YY') }}</span></p>
                <p><span class="bold">Age: </span><span>{{ ChildRecordData.Client.Person.AgeString }}</span></p>
                <p><span class="bold">Sex: </span><span>{{ ChildRecordData.Client.Person.Sex.Name }}</span></p>
                <p><span class="bold">CSW(s): </span><span>{{ ChildCSWs }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Foster Family</h4>
                <div v-if="CurrentResourceFamily != null">
                    <p><span class="bold">Name: </span><span>{{ CurrentResourceFamily.Name }}</span></p>
                    <p>
                        <span class="bold">Address: </span><span>{{ CurrentResourceFamily.Address.AddressSingleLine }} </span><GoogleMapsLink v-bind:address="CurrentResourceFamily.Address" />
                        <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && IsCaregiverSupport" v-on:click="ShowEditAddressModal()" class="pointer" />
                    </p>
                    <p><span class="bold">Placement Date: </span><span>{{ formatDate(CurrentResourceFamily.StartDate, 'MM/DD/YY') }}</span></p>
                    <div v-if="!EditMode">
                        <p v-if="CurrentResourceFamily.SFEmail"><span class="bold">Family Email: </span><span><a :href="'mailto:' + CurrentResourceFamily.SFEmail">{{ CurrentResourceFamily.SFEmail }}</a></span></p>
                        <p v-if="CurrentResourceFamily.SFPhoneNumber"><span class="bold">Family Phone: </span><span>{{ CurrentResourceFamily.SFPhoneNumber.FormattedPhoneNumber }}</span></p>
                    </div>
                    <div v-if="EditMode && IsCaregiverSupport">
                        <div class="form-group">
                            <label class="bold">Family Email:</label>
                            <input v-model="EditSFEmail" class="form-control" type="email" />
                        </div>
                        <div class="form-group">
                            <label class="bold">Family Phone:</label>
                            <input v-model="EditSFPhoneNumber" class="form-control" />
                        </div>
                        <b-button size="sm" variant="success" @click="SaveFamilyContactInfo()">SAVE</b-button>
                    </div>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>Program Enrollment</h4>
                <p><span class="bold">Regional Program: </span><span>{{ ChildRecordData.ClientProgramMembership.SubProgramName }}</span></p>
                <p><span class="bold">Placement Agency: </span><span>{{ ChildRecordData.ClientProgramMembership.PlacementAgency.Name }} </span></p>
                <p><span class="bold">Start Date: </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.StartDate, 'MM/DD/YY') }}</span></p>
                <p><span class="bold">End Date: </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.EndDate, 'MM/DD/YY', 'Present') }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Case Manager</h4>
                <div v-if="CurrentCaseManager != null">
                    <p><span class="bold">Name: </span><span>{{ CurrentCaseManager.Person.FullName }}</span></p>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
            <div v-if="IsPNW" class="col col-md-4">
                <h4>Reports</h4>
                <a :href="'API/Foster/Reports/ClientReports/GetPNWClientFaceSheet?Id=' + ChildRecordData.Id">Child Face Sheet</a>
            </div>
        </div>
        <!--EDIT ADDRESS MODAL-->
        <b-modal ref="edit-address-modal" title="Editing Family Address" hide-footer>
            <b-container>
                <b-form @submit="SaveAddress">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <span class="bold center-text underline">Old Address:</span>
                                <p v-if="CurrentResourceFamily">{{CurrentResourceFamily.Address.AddressSingleLine}}</p>
                                <label class="bold center-text underline">New Address:</label>
                            </div>
                            <div class="form-group">
                                <label>Address Line 1:</label>
                                <input type="text" class="form-control" v-model="EditAddress.AddressLine1" required />
                            </div>
                            <div class="form-group">
                                <label>Address Line 2:</label>
                                <input type="text" class="form-control" v-model="EditAddress.AddressLine2" />
                            </div>
                            <div class="form-group">
                                <label>City:</label>
                                <input type="text" class="form-control" v-model="EditAddress.City" required />
                            </div>
                            <div class="form-group">
                                <label>State:</label>
                                <select class="form-control" v-model="EditAddress.StateAbbreviation" required>
                                    <option v-for="option in StateOptions" :value="option.value">{{ option.text }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>County:</label>
                                <select class="form-control" v-model="EditAddress.County">
                                    <option value="">-- Select County --</option>
                                    <option v-for="option in CountyOptions" :value="option.value">{{ option.text }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Zip Code:</label>
                                <input type="text" class="form-control" v-model="EditAddress.ZipCode" required />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEditAddress()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <EditMode v-if="IsCaregiverSupport" :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    import EditMode from "../../../Core/ItemEditors/EditMode.vue";
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                ChildCSWs: "",
                EditMode: false,
                EditSFEmail: "",
                EditSFPhoneNumber: "",
                EditAddress: {}
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            GetCSWContacts() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Clients/Contacts/Professionals/GetContacts", { Id: this.ChildRecordData.ClientProgramMembership.Id }, this.GetCSWContactsSuccess, () => { }, true);
            },
            GetCSWContactsSuccess(response) {
                let vm = this;
                response.data.data.forEach(function (data) {
                    if ((data.ContactRelationship == "CSW" || data.ContactRelationship == "Adoption Worker" ) && data.EndDate == null) {
                        vm.ChildCSWs = vm.ChildCSWs + data.EntityContact.Person.FullName + ", ";
                    }
                });
                this.ChildCSWs = this.ChildCSWs.slice(0, this.ChildCSWs.length - 2); // remove comma in the end.
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
                if (this.EditMode && this.CurrentResourceFamily) {
                    this.EditSFEmail = this.CurrentResourceFamily.SFEmail || "";
                    this.EditSFPhoneNumber = this.CurrentResourceFamily.SFPhoneNumber ? this.CurrentResourceFamily.SFPhoneNumber.PhoneNumberDigits : "";
                }
            },
            SaveFamilyContactInfo() {
                this.$MasterAPI.ExecuteRequest(
                    "POST",
                    "Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/UpdateFamilyContactInfo",
                    {
                        FosterResourceFamilyID: this.CurrentResourceFamily.Id,
                        SFEmail: this.EditSFEmail,
                        SFPhoneNumber: this.EditSFPhoneNumber
                    },
                    this.SaveFamilyContactInfoSuccess,
                    () => { },
                    true
                );
            },
            SaveFamilyContactInfoSuccess(response) {
                this.EditMode = false;
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChildRecordData.Id);
            },
            ShowEditAddressModal() {
                if (this.CurrentResourceFamily && this.CurrentResourceFamily.Address) {
                    var countyValue = this.CurrentResourceFamily.Address.County || "";
                    var matchedCounty = this.CountyOptions.find(function (opt) {
                        var optLower = opt.value.toLowerCase();
                        var dbLower = countyValue.toLowerCase().trim();
                        return optLower === dbLower || optLower === dbLower + " county" || optLower.replace(" county", "") === dbLower;
                    });
                    this.EditAddress = {
                        AddressLine1: this.CurrentResourceFamily.Address.AddressLine1 || "",
                        AddressLine2: this.CurrentResourceFamily.Address.AddressLine2 || "",
                        City: this.CurrentResourceFamily.Address.City || "",
                        StateAbbreviation: this.CurrentResourceFamily.Address.StateAbbreviation || "",
                        County: matchedCounty ? matchedCounty.value : countyValue,
                        ZipCode: this.CurrentResourceFamily.Address.ZipCode || ""
                    };
                }
                this.$refs['edit-address-modal'].show();
            },
            CancelEditAddress() {
                this.$refs['edit-address-modal'].hide();
            },
            SaveAddress(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/Address/Update",
                    {
                        Id: this.CurrentResourceFamily.Address.Id,
                        AddressLine1: this.EditAddress.AddressLine1,
                        AddressLine2: this.EditAddress.AddressLine2,
                        City: this.EditAddress.City,
                        StateAbbreviation: this.EditAddress.StateAbbreviation,
                        County: this.EditAddress.County,
                        ZipCode: this.EditAddress.ZipCode
                    },
                    this.SaveAddressSuccess,
                    () => { },
                    true
                );
            },
            SaveAddressSuccess(response) {
                this.$refs['edit-address-modal'].hide();
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChildRecordData.Id);
            }
            
        },
        components: {
            GoogleMapsLink,
            EditMode
        },
        mounted() {
            this.GetCSWContacts();
        },
        computed: {
            CurrentResourceFamily: function() {
                let initList = this.ChildRecordData.ResourceFamilies.filter(fam => fam.EndDate == null);
                if (initList.length == 1) {
                    return initList[0];
                } else {
                    return null;
                }
            },
            CurrentCaseManager: function() {
                let initList = this.ChildRecordData.CaseManagers.filter(fam => fam.EndDate == null);
                if (initList.length == 1) {
                    return initList[0];
                } else {
                    return null;
                }
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.ChildRecordData.ClientProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            },
            IsCaregiverSupport: function () {
                let caregiverSupportSubProgramIDs = ['D9B74D70-B9B0-411C-BC1B-90B608036062',
                    'EACF40B6-EF88-41D0-BE4B-6D4F64950865',
                    '33E864F6-20F5-46A2-B586-1FD174DEFBFA',
                    '130F6819-F937-41A7-8FC0-29E052E1F6CC',
                    '12943A82-3156-4270-91A3-63200C6C4AE9',
                    '3F28D8CE-4CD8-4CC4-9984-9AE0BD645DA0'].map(id => id.toUpperCase());

                let subProgramID = this.ChildRecordData
                    && this.ChildRecordData.ClientProgramMembership
                    && this.ChildRecordData.ClientProgramMembership.SubProgramID;

                return !!subProgramID && caregiverSupportSubProgramIDs.includes(subProgramID.toUpperCase());
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            }
        }
    }
</script>

<style scoped>
</style>